import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import {
  TextColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';
import { hideScrollbars } from '@picsart/design-system/styleUtils/hideScrollbars';
import { textOverflowHidden } from '@/utils/styles/dsStyleHelpers';

const useStyles = createUseStyles(
  {
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
    },
    // Secondary header - hidden on all screen sizes (main Header provides context)
    header: {
      display: 'none',
    },
    headerIcon: {
      display: 'none',
    },
    content: {
      flex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      WebkitOverflowScrolling: 'touch',
      ...hideScrollbars,
      padding: Spacings.s16,
      paddingBottom: Spacings.s48, // Extra bottom padding for How It Works
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s12,
      // Small mobile padding
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        padding: Spacings.s12,
        paddingBottom: Spacings.s32, // Extra bottom padding for How It Works
        gap: Spacings.s8,
      },
    },
    descriptionWrapper: {
      position: 'relative',
    },
    presetDescription: {
      fontSize: FontSizes.t3,
      color: TextColors.tint1,
      margin: 0,
      lineHeight: LineHeights.t3,
      // Single line with ellipsis
      ...textOverflowHidden,
      // Prevent text selection and touch callouts (non-interactive text)
      userSelect: 'none',
      WebkitUserSelect: 'none',
      WebkitTouchCallout: 'none',
    },
    presetDescriptionExpanded: {
      whiteSpace: 'normal',
      overflow: 'visible',
      textOverflow: 'clip',
    },
    presetDescriptionClamped: {
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'normal',
    },
    // Reserve trailing room on every line so the ellipsis lands before the
    // absolutely-positioned "Show more" button and the two never overlap.
    presetDescriptionWithToggle: {
      paddingRight: `calc(${Spacings.s48} + ${Spacings.s24})`,
    },
    descriptionToggle: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      background: 'none',
      border: 'none',
      padding: 0,
      cursor: 'pointer',
      color: PrimaryColors.base.default,
      fontSize: FontSizes.t3,
      lineHeight: LineHeights.t3,
      fontWeight: FontWeights.semibold,
      userSelect: 'none',
      WebkitUserSelect: 'none',
      WebkitTouchCallout: 'none',
    },
    descriptionSheetHeading: {
      padding: [Spacings.s0, Spacings.s16, Spacings.s8, Spacings.s16],
    },
    descriptionSheetBody: {
      padding: [Spacings.s0, Spacings.s16, Spacings.s16, Spacings.s16],
      color: TextColors.base,
      fontSize: FontSizes.t4,
      lineHeight: LineHeights.t4,
      overflowY: 'auto',
      ...hideScrollbars,
      whiteSpace: 'pre-wrap',
    },
  },
  { name: 'create-content' }
);

export default useStyles;
